export default {
  internetBranch: {
    general: {
      active: 'Aktif',
      passive: 'Pasif'
    },
    login: {
      phoneNumberNull: 'Telefon numarası boş olamaz!',
      tcknNoNull: 'TCKN numarası boş olamaz!',
      userNotFound: 'Bu telefon numarasıyla kayıtlı bir kullanıcı bulunamadı!',
      anErrorOccurred: 'Bir hata oluştu'
    }
  },
  account: {
    yourProfile: 'Profiliniz',
    edit: 'Düzenle',
    payNow: 'Hemen Öde',
    lastDay: 'son günü',
    activeProject: 'Aktif Finansman Planlarınız',
    documents: 'Belgeleriniz',
    documentsLoad: 'Belgelerinizi Yükleyin',
    documentsSend: 'Belgelerinizi Gönderin',
    yourRepresentativeKnow: 'Temsilcinize Bildirin',
    ready: 'Artık Hazırsınız',
    load: 'Yükledim',
    joinCampaign: 'Katıldığınız Kampanyalar',
    yourAppointment: 'Randevularınız',
    yourProject: 'Finansman Planınız',
    projectDetail: 'Plan Detayı',
    newProject: 'Yeni Finansman Planı',
    installmentDay: 'Bugün taksit ödemenizin',
    projectDescription: 'Aktif finansman planlarınızı burada görebilir, tıklayarak detayına ulaşabilirsiniz.',
    loadDescription: 'Kimlik fotokopinizi, ikamet adres belgenizi ve adli sicil kaydınızı online olarak yükleyebilirsiniz.'
  }
};